<!--[style]='{w:width, h:height}|getStyles'-->
<div *ngIf='{ existSvg: arrPayMethod.includes(payMethod|getPayMethodName) } as obj'
     class='wrapperLogoPaySystem'>

  <meSvg *ngIf='obj.existSvg' [svgName]='svgName'></meSvg>
  <meSvg *ngIf='!obj.existSvg && payMethod?.cardDto' svgName='payment_unknown'></meSvg>
  <meSvg *ngIf='!obj.existSvg && payMethod?.bankAccountDto' svgName='payment_bankTransfer'></meSvg>
</div>
